import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetSeamVisionlineIsConnectedRequest = {
  clientId: string
}

export const getSeamVisionlineIsConnectedQueryKey = (data: GetSeamVisionlineIsConnectedRequest) => [
  'useGetSeamVisionlineIsConnected',
  data,
]

const getSeamVisionlineIsConnected = async (data: GetSeamVisionlineIsConnectedRequest) => {
  const response = await authAPI.get<boolean>(
    `/seam-visionline/users/${data.clientId}/is-connected`,
  )
  return response.data
}

export const useGetSeamVisionlineIsConnected = (data: GetSeamVisionlineIsConnectedRequest) =>
  useQuery({
    enabled: Boolean(data.clientId),
    queryFn: () => getSeamVisionlineIsConnected(data),
    queryKey: getSeamVisionlineIsConnectedQueryKey(data),
  })
